export const brokerUrl = 'https://broker.spcoco.org';

// FIXME: glue response from local CO
export const occurrenceDataProviders = ['gbif', 'idb', 'mopho'];
export const speciesDataProviders = ['gbif', 'itis', 'worms'];
